import React, { Fragment, useEffect, useState } from "react";
import {
  Input,
  Button,
  Label,
  FormGroup,
  FormFeedback,
  Row,
  Col,
  FormText,
  Form
} from "reactstrap";
import { connect } from "react-redux";
import {
  clearCreateOrganisationError,
  createOrganisation,
  setOrganisationFormInitialState
} from "../../store/organisation/actions.js";
import Message from "../../CommonData/Data/Message.js";
import { clearForm, updateForm } from "../../store/form/actions.js";
import Async from "react-select/async";
import { getFilteredStatesForAsyncSelect } from "../../store/actions.js";
import VWLoading from "../../components/vwLoading/vwLoading.js";
import Select from "react-select";
import { orgTypeOption } from "../../store/organisation/actionTypes.js";

const AddOrganisation = (props) => {

  const { form, handleClose, errorMessage, isPending } = props || {};
  const { formAddOrg } = form || {};
  const { name, addressLine1, addressLine2, city, country, pincode, applicationName, allowCustomerSelfRegistration, approveNewCustomer,
    enableUserMailNotification, isReturnApproval, isEnableApiAccess, isEnableOnlySwitchMobileApp } = formAddOrg || {};
  const [selected_state, setState] = useState();
  const [selected_orgType, setOrgType] = useState();

  useEffect(() => {
    props.updateForm({
      formAddOrg: {
        ...form.formAddOrg,
        approveNewCustomer: false,
        allowCustomerSelfRegistration: false,
        enableUserMailNotification: false,
      },
      errors: {}
    })
    props.clearCreateOrganisationError();
    if (Object.keys(form).length > 0) {
      props.clearForm();
    }
    //--------------------Key-Listener----------------------
    const handleKeyPress = (e) => {
      if (e.key === "Escape") {
        handleClose();
      }
    };

    window.addEventListener('keydown', handleKeyPress);
    return () => {
      window.removeEventListener('keydown', handleKeyPress);
      props.clearCreateOrganisationError();
      props.clearForm();
    }
  }, [])

  const handleInputChange = (event) => {
    const { name } = event.target;
    const input = event.target;
    const value = input.type === 'checkbox' ? input.checked : input.value;
    props.updateForm({
      formAddOrg: {
        ...form.formAddOrg,
        [name]: value
      },
      errors: {
        ...form && form.errors,
        [name]: null,
      }
    });
  }
  const handleLoadStates = (inputValue, callback) => {
    props.getFilteredStatesForAsyncSelect(inputValue, callback);
  };

  const handleStateChange = (value) => {
    setState(value);
    props.updateForm({
      formAddOrg: {
        ...form.formAddOrg,
        state: value ? value.value : "",
      },
      errors: {
        ...form && form.errors,
        state: null,
      }

    });
  }

  const handleOrgTypeChange = (value) => {
    setOrgType(value);
    props.updateForm({
      formAddOrg: {
        ...form.formAddOrg,
        orgType: value ? value.value : "",
      },
      errors: {
        ...form && form.errors,
        orgType: null,
      }

    });
  }

  const handleKeyDown = (e) => {
    if (e.key === ",") {
      e.preventDefault();
    }
  };

  const handleLogoChange = (event) => {
    const filedata = event.target.files[0];
    if (filedata) {
      const img = new Image();
      const reader = new FileReader();
      const imageSize = filedata.size;
      const imageSizeInKB = imageSize / 1024;

      reader.onloadend = () => {
        img.src = reader.result;
        img.onload = () => {
          if (imageSizeInKB > 200) {
            props.updateForm({
              formAddOrg: {
                ...form.formAddOrg,
                applicationLogo: null,
              },
              errors: {
                ...form && form.errors,
                applicationLogo: "Image size should below 200 kb.",
              }
            });
          }
          else if (img.width > 900 || img.height > 350) {
            props.updateForm({
              formAddOrg: {
                ...form.formAddOrg,
                applicationLogo: null,
              },
              errors: {
                ...form && form.errors,
                applicationLogo: "Image dimensions should not exceed 900px in width and 350px in height.",
              }
            });
          }
          else {
            props.updateForm({
              formAddOrg: {
                ...form.formAddOrg,
                applicationLogo: reader.result,
              },
              errors: {
                ...form && form.errors,
                applicationLogo: null,
              }
            });
          }
        };
      };
      reader.readAsDataURL(filedata);
    }
  }

  const handleCreateOrganisation = (e) => {
    e.preventDefault();
    const { formAddOrg, errors } = form || {};
    const { name, addressLine1, city, state, country, pincode, orgType } = formAddOrg || {};
    const { applicationLogo } = errors || {};

    const currentErrors = {};

    if (!name) {
      currentErrors.name = "Organization name is required"
    }
    if (!orgType) {
      currentErrors.orgType = "Organization type is required"
    }
    if (!addressLine1) {
      currentErrors.addressLine1 = "Address is required"
    }
    if (!city) {
      currentErrors.city = "City is required"
    }
    if (!state) {
      currentErrors.state = "State is required"
    }
    if (!country) {
      currentErrors.country = "Country is required"
    }
    if (!pincode) {
      currentErrors.pincode = "Pincode is required"
    }
    if (applicationLogo) {
      currentErrors.applicationLogo = applicationLogo
    }

    props.updateForm({
      formAddOrg: {
        ...form.formAddOrg,
      },
      errors: currentErrors,
    })
    if (Object.keys(currentErrors).length === 0) {
      props.createOrganisation(form.formAddOrg);

    }
  };

  return isPending ? (<VWLoading />) : (
    <Fragment>
      <Form className="mb-3" name="formAddOrganisation" onSubmit={handleCreateOrganisation}>
        {errorMessage && (
          <Message
            type="danger"
            defaultMessage={errorMessage}
            baseClassName="alert"
          />
        )
        }
        <Row>
          <Col md={6} sm={12}>
            <FormGroup>
              <Label>
                Organization Name<span className="text-danger">*</span>
              </Label>
              <Input
                autoFocus
                type="text"
                name="name"
                placeholder="Enter organization name"
                onChange={handleInputChange}
                value={name || ""}
                invalid={form && form.errors && form.errors.name}
              />
              <FormFeedback>{form && form.errors && form.errors.name}</FormFeedback>
            </FormGroup>
          </Col>
          <Col md={6} sm={12}>
            <FormGroup>
              <Label>
                Organization Type<span className="text-danger">*</span>
              </Label>
              <Select
                styles={{
                  control: (baseStyles) => ({
                    ...baseStyles,
                    borderColor: (form && form.errors && form.errors.orgType) ? 'red' : ""
                  })
                }}
                placeholder="Select organization type"
                defaultOptions
                options={orgTypeOption}
                onChange={handleOrgTypeChange}
                defaultValue={selected_orgType || ""}
              />
              {(form && form.errors && form.errors.orgType) &&
                <FormText sx={{ marginLeft: "10px" }}>
                  <div className="text-danger">
                    {form && form.errors && form.errors.orgType}
                  </div>
                </FormText>
              }
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col md={6} sm={12}>
            <FormGroup>
              <Label>
                Address Line 1<span className="text-danger">*</span>
              </Label>
              <Input
                type="textarea"
                name="addressLine1"
                placeholder="Enter address"
                onChange={handleInputChange}
                value={addressLine1 || ""}
                invalid={form && form.errors && form.errors.addressLine1}
                onKeyDown={handleKeyDown}
              />
              <FormFeedback>{form && form.errors && form.errors.addressLine1}</FormFeedback>
            </FormGroup>
          </Col>
          <Col md={6} sm={12}>
            <FormGroup>
              <Label >
                Address Line 2
              </Label>
              <Input
                type="textarea"
                name="addressLine2"
                placeholder="Enter address"
                value={addressLine2 || ""}
                onChange={handleInputChange}
                onKeyDown={handleKeyDown}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col md={6} sm={12}>
            <FormGroup>
              <Label>
                City<span className="text-danger">*</span>
              </Label>
              <Input
                type="text"
                name="city"
                placeholder="Enter city"
                onChange={handleInputChange}
                value={city || ""}
                invalid={form && form.errors && form.errors.city}
              />
              <FormFeedback>{form && form.errors && form.errors.city}</FormFeedback>
            </FormGroup>
          </Col>
          <Col md={6} sm={12}>
            <FormGroup>
              <Label htmlFor="basicpill-servicetax-input8">
                State
              </Label><span className="text-danger">*</span>
              <Async
                styles={{
                  control: (baseStyles) => ({
                    ...baseStyles,
                    borderColor: (form && form.errors && form.errors.state) ? 'red' : ""
                  })
                }}
                placeholder="Select State"
                defaultOptions
                loadOptions={handleLoadStates}
                onChange={handleStateChange}
                defaultValue={selected_state || ""}
              />
              {(form && form.errors && form.errors.state) &&
                <FormText sx={{ marginLeft: "10px" }}>
                  <div className="text-danger">
                    {form && form.errors && form.errors.state}
                  </div>
                </FormText>
              }
            </FormGroup>
          </Col>
        </Row>
        <Row className="d-flex align-items-center">
          <Col md={6} sm={12}>
            <FormGroup>
              <Label>
                Country<span className="text-danger">*</span>
              </Label>
              <Input
                type="text"
                name="country"
                placeholder="Enter country"
                onChange={handleInputChange}
                value={country || ""}
                invalid={form && form.errors && form.errors.country}
              />
              <FormFeedback>{form && form.errors && form.errors.country}</FormFeedback>
            </FormGroup>
          </Col>
          <Col md={6} sm={12}>
            <FormGroup>
              <Label>
                Pincode<span className="text-danger">*</span>
              </Label>
              <Input
                type="text"
                name="pincode"
                placeholder="Enter pincode"
                onChange={handleInputChange}
                value={pincode || ""}
                invalid={form && form.errors && form.errors.pincode}
              />
              <FormFeedback>{form && form.errors && form.errors.pincode}</FormFeedback>
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col md={6} sm={12}>
            <FormGroup>
              <Label>Application Name</Label>
              <Input
                name='applicationName'
                type='text'
                placeHolder='Enter application name'
                onChange={handleInputChange}
                value={applicationName || ""}
              />
            </FormGroup>
          </Col>
          <Col md={6} sm={12}>
            <FormGroup>
              <Label>Application Logo</Label>
              <Input
                name='applicationLogo'
                type='file'
                accept="image/png, image/gif, image/jpeg"
                onChange={handleLogoChange}
                invalid={form && form.errors && form.errors.applicationLogo}
              />
              <FormFeedback>{form && form.errors && form.errors.applicationLogo}</FormFeedback>
            </FormGroup>
          </Col>
        </Row>
        <Row className="my-4">
          <Col md={6} sm={12}>
            <Input
              className="me-2"
              type="checkbox"
              name="approveNewCustomer"
              onChange={handleInputChange}
              value={approveNewCustomer || ""}
            />
            <Label>
              Approve New Customer?
            </Label>
          </Col>
          <Col md={6} sm={12}>
            <Input
              className="me-2"
              type="checkbox"
              name="allowCustomerSelfRegistration"
              onChange={handleInputChange}
              checked={allowCustomerSelfRegistration || ""}
            />
            <Label>
              Allow Customer Self Registration?
            </Label>
          </Col>
          <Col md={6} sm={12}>
            <Input
              className="me-2"
              type="checkbox"
              name="enableUserMailNotification"
              onChange={handleInputChange}
              checked={enableUserMailNotification || ""}
            />
            <Label>
              Enable Email Notification To Customer?
            </Label>
          </Col>
          <Col md={6} sm={12}>
            <Input
              className="me-2"
              type="checkbox"
              name="isReturnApproval"
              onChange={handleInputChange}
              checked={isReturnApproval || ""}
            />
            <Label>
              Enable Return Device Without Approval?
            </Label>
          </Col>
          <Col md={6} sm={12}>
            <Input
              className="me-2"
              type="checkbox"
              name="isEnableApiAccess"
              onChange={handleInputChange}
              checked={isEnableApiAccess || ""}
            />
            <Label>
              Enable API Access?
            </Label>
          </Col>
          <Col md={6} sm={12}>
            <Input
              className="me-2"
              type="checkbox"
              name="isEnableOnlySwitchMobileApp"
              onChange={handleInputChange}
              checked={isEnableOnlySwitchMobileApp || ""}
            />
            <Label>
              Enable Only Switch Mobile App?
            </Label>
          </Col>
        </Row>
        <FormGroup>
          <Button
            type="submit"
            color="success"
            onClick={handleCreateOrganisation}
          >Create
          </Button>&nbsp;&nbsp;
          <Button
            color="danger"
            onClick={handleClose}
          >Cancel
          </Button>
        </FormGroup>
      </Form >
    </Fragment >
  );
}

const mapStateToProps = (state) => ({
  AddOrganisation: state.organisation.AddOrganisation,
  isPending: state.organisation.isPending,
  errorMessage: state.organisation.errorMessage,
  form: state.form.form,
});

const mapDispatchToProps = (dispatch) => ({
  updateForm: (AddOrganisation) => dispatch(updateForm(AddOrganisation)),
  clearForm: () => dispatch(clearForm()),
  createOrganisation: (organisation) => dispatch(createOrganisation(organisation)),
  setOrganisationFormInitialState: () => dispatch(setOrganisationFormInitialState()),
  clearCreateOrganisationError: () => dispatch(clearCreateOrganisationError()),
  getFilteredStatesForAsyncSelect: (searchValue, callback) => dispatch(getFilteredStatesForAsyncSelect(searchValue, callback)),

});

export default connect(mapStateToProps, mapDispatchToProps)(AddOrganisation);
